<template>
  <div class="contact-list">
    <div class="contact-list-title" v-if="contacts.length > 0">Contact <span class="list">List</span></div>
    <transition-group name="contact" tag="div">
      <contact-item
        v-for="contact in contacts"
        :key="contact.identity"
        :contact="contact"
        :call-loading="callLoading"
        :is-deleting="isDeleting"
        @call="onCall"
        @delete="deleteContact"
        @showInfo="onShowInfo"
      />
    </transition-group>
    <contact-info-modal :contact="currentContact"  @close="onClose"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import ContactItem from "./ContactItem";
  import ContactInfoModal from "./ContactInfoModal";

  export default {
    name: 'ContactList',
    components: {ContactInfoModal, ContactItem},
    props: {
      contacts: {
        type: Array
      },
      callLoading: {
        type: String,
        required: false
      }
    },

    data: () => ({
      isDeleting: false,
      currentContact: null
    }),

    methods: {
      onCall({contact, shouldRecord}) {
        this.$emit('call', {contact, shouldRecord})
      },
      deleteContact(contact) {
        this.isDeleting = true;
        this.$store.dispatch('contacts/delete', contact.id)
          .then(() => {
            this.isDeleting = false;
          })
          .catch(() => {
            this.isDeleting = false;
          })
      },
      onShowInfo(contact) {
        this.currentContact = contact
      },
      onClose() {
        this.currentContact = null
      }
    }
  }
</script>

<style lang="scss">
  @import "ContactList";
</style>
